module.exports = __webpack_public_path__ + "img/cancel_sign.940f5456.svg";